<mat-chip-list>
    <mat-chip *ngFor="let item of panelStatus.neighborQueue" [ngClass]="{ backgroundfailed: item.failed === true }"> 
        <span style="font-size: 16px;">{{ item.mac }}</span>
        <mat-icon *ngIf="item.failed" class="mat-icon-button-sm">close</mat-icon>
        <mat-spinner *ngIf="!item.failed" diameter="20" style="margin-left: 4px"></mat-spinner>
    </mat-chip>
</mat-chip-list>


